<ion-header class="balanced-title-header title-content-gap ion-no-border">
  <ion-toolbar class="header_toolbar">
    <div class="balanced-title-row">
      <ion-back-button class="balanced-title-back" defaultHref="/welcome" icon="chevron-back-outline" text=""></ion-back-button>
      <h1 class="balanced-title">Login</h1>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="content-padding">
  <app-info-window-dialog [showInfow]="showInfoWindow"  [title]="infoWindowTitle" [descr]="infoWindowDescription" [button]="infoWindowCloseText"></app-info-window-dialog>
  <form id="login-form"
        class="login-form-form"
        #userForm="ngForm"
        autocomplete="on"
        (ngSubmit)="doLogin(userForm)"
        padding>
    <input
      type="email"
      name="username"
      autocomplete="username"
      [value]="account.email"
      hidden>
    <ion-list class="login-form-list">
      <h4 class="input-pseudo-label">Please enter your password</h4>
      <div class="item-wrapper" [ngClass]="{'valid-field': !userPassword.errors && userPassword.touched}">
        <ion-item class="login-form-item" no-lines>
          <ion-label position="stacked">Password</ion-label>
          <ion-input #inputToFocus  class="login-form-input passwordInput"
                     id="current-password"
                     [type]="passwordType"
                     autocomplete="current-password"
                     [(ngModel)]="account.password"
                     name="password"
                     #userPassword="ngModel"
                     pattern="^\S+$"
                     required
                     [ngClass]="{'is-invalid':userPassword.errors && userPassword.touched}"
                     placeholder="Enter your password"
                     clearOnEdit="false"
                     (focus)="setCaretPosition($event)"
          >
          </ion-input>
          <button type="button" item-end class="passwordIcon" (click)='hideShowPassword($event)'><span [ngClass]="passwordIcon"></span></button>

        </ion-item>
      </div>
    </ion-list>

    <div>
      <div left class="signIn-form-forgotten" (click)="goTo('reminder', {email: account.email})">
        Forgotten Password?
      </div>
    </div>

    <br>
    <br>
  </form>
</ion-content>

<ion-footer class="onboarding-footer">
  <ion-toolbar>
    <div  class="sign-up-button ion-text-center">
      <ion-button type="submit" form="login-form" expand="block" class="submit-button" [disabled]="userPassword.errors">Login</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
